//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

const WINDOWS_1252_PATTERN =
  '[^\\u0000-\\u007FƒŠŒŽšœžŸªµº©™®\\u00c0-\\u00d6\\u00d8-\\u00f6\\u00f8-\\u00ff]';
const LABELS_SANITIZE_PATTERN =
  WINDOWS_1252_PATTERN + '|[&,:;=@#|+?><~{}^()`/\\]\\[!$"%\'\\\\©®™.*]';
const INVALID_LABEL_REGEX = new RegExp(LABELS_SANITIZE_PATTERN, 'g');

export const validateLabelName = (label: string) => {
  if (label.includes(' ')) {
    return false;
  }
  if (label.length > 0) {
    return !INVALID_LABEL_REGEX.test(label);
  }
};
